import { Component, OnInit, Input } from '@angular/core';
import { AppSelectorService } from '../../../shared/services/app-selector/app-selector.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DocsLink } from 'src/app/shared/constants/docs-link';

@Component({
  selector: 'app-non-initialised',
  templateUrl: './non-initialised-app.component.html',
  styleUrls: ['./non-initialised-app.component.scss']
})
export class NonInitialisedAppComponent {
  @Input() message: any;
  @Input() href: any;
  @Input() buttonName: any;
  @Input() newPage: Boolean;
  constructor() {
  }
}
